// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"509dd984","455":"98f7ae70"}[chunkId] + ".chunk.js";
};